import { render, staticRenderFns } from "./KinerjaKontrak-Bottom.vue?vue&type=template&id=72ca2157&"
import script from "./KinerjaKontrak-Bottom.vue?vue&type=script&lang=js&"
export * from "./KinerjaKontrak-Bottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports